<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("stock_on_hand_by_item")}}</h4>
                <p class="text-subtitle-1">{{$t("show_stock_on_hand_by_item_in_all_warehouses")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockOnHandItemReport :warehouseId="warehouseId" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import StockOnHandItemReport from './../../components/warehouse/StockOnHandItemReport.vue'
export default {
    name: "StockOnHandItemReportView",
    components: { StockOnHandItemReport },
    data() {
        return {
            warehouseId: null
        }
    },
    created() {
       this.form.warehouse_id = this.$route.params.warehouseId
    }
}
</script>

<style>

</style>